export function useEmailConfirmation() {
  const userStore = useUserStore()
  const toast = useToast()

  const isUnconfirmedHomePageSignup = computed(() => {
    return (
      userStore.loggedIn &&
      !userStore.emailConfirmed &&
      (userStore.signupSource || "home_page") === "home_page" &&
      !userStore.approvedCreator
    )
  })

  const requiresFullEmailConfirmation = computed(() => {
    return (
      userStore.loggedIn &&
      !userStore.emailConfirmed &&
      !isUnconfirmedHomePageSignup.value
    )
  })

  const blockUnconfirmedAction = (
    message = "Please confirm your email before performing this action.",
  ) => {
    if (userStore.loggedIn && !userStore.emailConfirmed) {
      toast.add({
        title: message,
        color: "yellow",
        timeout: 5000,
      })
      return true
    }

    return false
  }

  return {
    isUnconfirmedHomePageSignup,
    requiresFullEmailConfirmation,
    blockUnconfirmedAction,
  }
}
